AddressItemView = require('./address-item-view')

class AddressCollectionView extends Marionette.CollectionView
  childView: AddressItemView

  childViewOptions: ->
    countries: @options.countries
    collection: @collection

module.exports = AddressCollectionView